<template>
  <div>
    <div class="flowItme" v-if="itemState">
    <div class="redLine">
      <span class="lineFlag" :class="{'normalLineFlag':!itemState.lineFlag}"></span>
    </div>
    <div class="flowItemContent">
      <div
        class="contentTop"
        v-if="detailItem.txId || isShowBlockIdBox"
        v-loading="!detailItem.txId&&isGetRejectSuccess"
      >
        <div class="blockLineDscp">区块链记录ID:</div>
        <div class="blockLineId" v-if="isGetRejectSuccess&&detailItem.txId">{{detailItem.txId}}</div>
        <div class="blockLineId" v-if="!isGetRejectSuccess&&!detailItem.txId">获取失败</div>
        <div class="blockSign"></div>
        <div class="saved"></div>
      </div>
      <div class="contentTop paddingBox" v-else></div>
      <div class="contentMiddle">
        <span class="compoentLine">
          <span class="lineFlag" :class="{'normalLineFlag':!itemState.lineFlag}"></span>
        </span>
        <span class="compoentFlag" :class="{'normalCompoentFlag':!itemState.lineFlag}"></span>
        <span class="compoentLine">
          <span
            class="lineFlag"
            :class="{'normalLineFlag':!itemState.lineFlag||(itemState.lineFlag&&activeIndex&&!lastIndex)}"
          ></span>
        </span>
      </div>
      <div class="contentBottom">
        <div
          class="signName ellipsis"
          :class="{'signNameNormal':!itemState.lineFlag}"
        >{{detailItem.signUser.name}}</div>
        <div class="signHandler">
          <span v-for="(item,index) in itemState.status" :key="index">{{item}}</span>
          <span
            v-if="itemState.handler&&!(judgeArrHandler('SIGN')&&isLastMeFlag)"
            class="handler"
            @click="tipPerson"
          >提醒</span>
          <span
            v-if="judgeArrHandler('SIGN')&&isLastMeFlag && detail.info.signStatus == 1"
            @click="toSignTrue(detail)"
            class="handler"
          >去签署</span>
          <span
            v-if="judgeArrHandler('SIGN')&&isLastMeFlag&&detail.contractUser.userId!=signUserId && detail.info.signStatus == 1"
            class="handler"
            @click="reject(detail)"
          >拒签</span>
          <span
            v-if="judgeArrHandler('CONFIRM')&&stopLastIndex"
            @click="stopContract(detail,true)"
            class="handler"
          >终止</span>
          <span
            v-if="judgeArrHandler('CONFIRM')&&stopLastIndex"
            @click="stopContract(detail,false)"
            class="handler"
          >继续签</span>
        </div>
        <div v-if="detailItem.signStatusTime" class="time">{{detailItem.signStatusTime}}</div>
        <div
          class="contentTop bottomCustomer"
          v-if="detailItem.signature ||isShowBlockIdBox"
          v-loading="!detailItem.signature&&isGetRejectSuccess"
        >
          <div class="blockLineDscp">数字签名：</div>
          <div class="blockLineId">{{detailItem.signature}}</div>
          <div class="blockSign"></div>
        </div>
      </div>
    </div>
    <div class="redLine">
      <span
        class="lineFlag"
        :class="{'normalLineFlag':!itemState.lineFlag||(itemState.lineFlag&&activeIndex&&!lastIndex)}"
      ></span>
    </div>
    <Dialog
      :visible="stopDialogShow"
      :dialogTitle="'消息提示'"
      :width="'400px'"
      @closeDialog="stopDialogShow = false"
      :appendToBody="true"
    >
      <div class="signDialog" slot="dialog">
        <div class="authDscp">
          <p>确定要终止掉这份合同吗？</p>
        </div>
        <div class="authHandlerBox">
          <div class="button cursorPointer" @click="stopDialogShow = false">取消</div>
          <div class="button buttonActive cursorPointer" @click="stopContractReq()">确定</div>
        </div>
      </div>
    </Dialog>
  </div>
  </div>
</template>

<script>
import BaseApi from "@lib/baseApi.js";
import Dialog from "@common/Dialog.vue";
export default {
  props: [
    "detailItem",
    "detail",
    "isLastMeFlag",
    "stopLastIndex",
    "returnLastIndex",
    "activeIndex",
    "lastIndex"
  ],
  data() {
    let handlerDetail = this.getTaskId(this.detail.taskList, "SIGN", true);
    return {
      userId: localStorage.userId,
      itemState: null,
      signUserId: handlerDetail && handlerDetail.userId,
      isRequest: false,
      stopDialogShow: false,
      // 拒签轮训的次数
      count: 1,
      //是否通过轮训获取的id
      isGetRejectSuccess: true,
      isShowBlockIdBox: false
    };
  },
  created() {
    this.itemState = this.handlerStatus();
    // console.log(this.detailItem);
  },
  mounted() {},
  components: { Dialog },
  methods: {
    getTaskId(data, flag, getItemFlag) {
      // console.log(this.detailItem.signUser)
      if (data && data.length) {
        for (let i = 0; i < data.length; i++) {
          // console.log(data[i])
          // 找到
          if (
            data[i].actionCode === flag &&
            this.detailItem.signUser.userId == data[i].userId
          ) {
            if (getItemFlag) {
            //  console.log(data[i])
              return data[i];
            } else {
              return data[i].taskId;
            }
          }else if(data[i].datas){
              if(data[i].actionCode === flag && this.detailItem.signUser.userId==data[i].datas.rejectUserId){
                return data[i];
              }
          }else{ }
        }
      }
    },
     toSignTrue(detail) {
      //  console.log(detail,"Dasdasdas")
      let taskId = this.getTaskId(detail.taskList, "SIGN");
      let isCanReject = 1;
      if (detail.contractUser.userId == this.signUserId) {
        isCanReject = 0;
      }
      // 判断是否已经支付过
      this.getContractInfo().then((data)=> {
          if (data.datas.info.payStatus == 0) {
            //未支付，去支付
            this.$router.push({
              path:"/personal/payment",
              query:{ 
                id: this.$route.query.id,
                flag:'Sign',
                taskId:taskId,
                isCanReject:isCanReject,
                isHandwriting:false,
                type:detail.info.type
              }
            })
          } else {
             //已支付，去签署,1-普通合同；2-赋强合同,4-调解赋强签署
                if(detail.info.type==1){
                  this.$router.push(
                    `/personal/sign/index/signature?isHandwriting=false&id=${
                      this.$route.query.id
                    }&taskId=${taskId}&isCanReject=${isCanReject}`
                  );
                }else if(detail.info.type==2){  
                  this.$router.push(
                    `/personal/sign/signLoanIndex?isHandwriting=false&id=${
                       this.$route.query.id
                    }&taskId=${taskId}&isCanReject=${isCanReject}`
                  );
                }else{
                  this.$router.push(
                    `/personal/sign/signMediate?isHandwriting=false&id=${
                      this.$route.query.id
                    }&taskId=${taskId}&isCanReject=${isCanReject}`
                  );
                }
          }
        })
    },
    getContractInfo() {
      return BaseApi.createRpcToken(
        "/contract/info",
        { id: this.$route.query.id },
        "post"
      );
    },
    reject(detail) {
      
      let rejectTaskId = this.getTaskId(detail.taskList, "SIGN");
      // console.log(rejectTaskId);
      this.$emit("rejectSignShow", rejectTaskId);
    },
    stopContract(detail, flag) {
      if (flag) {
        this.stopContaractParams = detail;
        this.stopFlag = flag;
        this.stopDialogShow = true;
        console.log(detail,flag,"231231",this.stopDialogShow)

      } else {
        this.stopContractReq(detail, flag);
      }
    },
    stopContractReq(detail, flag) {
      detail = detail || this.stopContaractParams;
      if (flag !== false) {
        flag = true;
      }
      // console.log(this.isRequest)
      if (!this.isRequest) {
        this.isRequest = true;
        // console.log(detail.taskList)
        let taskItem = this.getTaskId(detail.taskList, "CONFIRM", true);
        // console.log(taskItem)
        BaseApi.createRpcToken(
          " /contract/confirm",
          {
            id: this.$route.query.id,
            taskId: taskItem.taskId,
            approve: flag,
            rejectUserId:
              taskItem && taskItem.datas && taskItem.datas.rejectUserId
          },
          "post"
        )
          .then(
            data => {
              if (data.datas.success) {
                this.$message.success("合同操作成功");
                this.$emit("restDetail");
                this.stopDialogShow = false;
              } else {
                this.$message.error("合同操作失败");
                this.isRequest = false;
              }
            },
            () => {
              this.isRequest = false;
            }
          )
          .catch(function(e) {
            errorLog(e);
          });
      }else{
        // console.log("继续签")
      }
    },
    tipPerson() {
      BaseApi.createRpcToken(" /contract/remind", {
        id: this.$route.query.id
      })
        .then(data => {
          if (data.datas.success) {
            this.$message.success("已发送提醒");
          } else {
            this.$message.error("发送失败");
          }
        })
        .catch(function(e) {
          errorLog(e);
        });
    },
    judgeArrHandler(contractArrFlag) {
      if (this.detail.taskList && this.detail.taskList.length) {
        for (let i = 0; i < this.detail.taskList.length; i++) {
          if (this.detail.taskList[i].actionCode == contractArrFlag) {
            return true;
          }
        }
        return false;
      } else {
        return false;
      }
    },
    getBlockInfoForSign(flag) {
      BaseApi.createRpcToken("/contract/queryTxId", {
        id: this.$route.query.id,
        sign: false,
        signUserId: this.detailItem.signUser && this.detailItem.signUser.userId
      })
        .then(
          data => {
            this.detailItem.txId = (data.datas && data.datas.txId) || "";
            this.detailItem.signature =
              (data.datas && data.datas.signature) || "";
            this.$forceUpdate();
            if (this.detailItem.txId && this.detailItem.signature) {
              this.isGetRejectSuccess = true;
            } else if (!this.detailItem.txId && this.count == 13) {
              this.isGetRejectSuccess = false;
            }
          },
          () => {}
        )
        .catch(function(e) {
          errorLog(e);
        });
      this.count++;
    },
    loopBlockDetail() {
      if (this.count < 13 && !this.detailItem.txId) {
        this.getBlockInfoForSign();
        setTimeout(() => {
          this.loopBlockDetail();
        }, 5000);
      }
    },
    handlerStatus() {
      let status = [],
        handler;
      if (this.detailItem.signStatus == 1) {
        if (this.detail.info.signStatus == 1) {
          if (this.detail.info.orderType == 1) {
            if (this.detailItem.signAvailable) {
              if (
                this.detailItem.signUser.userId != this.userId &&
                (!this.detailItem.signUser.agentUser ||
                  this.detailItem.signUser.agentUser.userId != this.userId)
              ) {
                status = ["未签"];
                handler = "提醒";
              } else {
                status = ["待我签"];
              }
            } else {
              status = ["待他人签"];
            }
          } else if (this.detail.info.orderType == 0) {
            status = ["未签"];
            if (
              this.detailItem.signUser.userId != this.userId &&
              (!this.detailItem.signUser.agentUser ||
                this.detailItem.signUser.agentUser.userId != this.userId)
            ) {
              handler = "提醒";
            }
          }
        } else {
          status = ["未签"];
        }
      } else if (this.detailItem.signStatus === 2) {
        status = ["已签"];
      } else if (this.detailItem.signStatus === 0) {
        status = ["发起签约"];
      } else if (this.detailItem.signStatus == 3) {
        if (
          this.stopLastIndex &&
          this.detail.info.signStatus == 3 &&
          this.detail.info.terminationType == 2
        ) {
          status = ["已终止"];
        } else {
          //只有拒签的时候；
          if (!this.detailItem.txId) {
            this.isShowBlockIdBox = true;
            this.loopBlockDetail();
          }
        }
        status.push("拒签");
      } else if (this.detailItem.signStatus == 4) {
        if (
          this.returnLastIndex &&
          this.detail.info.signStatus == 3 &&
          this.detail.info.terminationType == 1
        ) {
          status = ["已终止"];
        }
        status.push("撤回");
      }
      // console.log(handler);
      console.log({
        status: status,
        handler: handler,
        lineFlag: this.detailItem.signStatusTime
      })
      return {
        status: status,
        handler: handler,
        lineFlag: this.detailItem.signStatusTime
      };
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.flowItme {
  width: 240px;
  display: flex;
  .time {
    font-size: 12px;
    color: #ea8e87;
    text-align: center;
    line-height: 12px;
    margin-bottom: 10px;
  }
  .flowItemContent {
    width: 180px;
    .contentTop {
      width: 180px;
      height: 88px;
      position: relative;
      box-sizing: border-box;
      padding: 10px;
      background: #f8f8f8;
      margin-bottom: 22px;
      border: 1px solid #f0f0f0;
      .blockLineDscp {
        font-size: 12px;
        color: #646464;
        line-height: 24px;
      }
      .blockLineId {
        font-size: 12px;
        color: #969696;
        text-align: justify;
        line-height: 14px;
        word-break: break-all;
        word-spacing: normal;
      }
      .saved {
        position: absolute;
        width: 94px;
        height: 76px;
        top: 0;
        right: 0;
        background: url(./../../../../../assets/images/personalSignDetail/savedline.png);
        background-size: 94px 76px;
      }
    }
    .paddingBox {
      background: #ffffff;
      border: none;
    }
    .contentMiddle {
      height: 20px;
      box-sizing: border-box;
      width: 100%;
      margin-bottom: 20px;
      .compoentFlag {
        vertical-align: middle;
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 5px;
        margin-left: 5px;
        background: url(./../../../../../assets/images/personalSignDetail/Circlereach_icon.png);
        background-size: 100%;
      }
      .normalCompoentFlag {
        background: url(./../../../../../assets/images/personalSignDetail/Circlereachnor_icon.png);
        background-size: 100%;
      }
      .compoentLine {
        display: inline-block;
        width: 75px;
        height: 20px;
        padding-top: 10px;
        .lineFlag {
          width: 75px;
          display: inline-block;
          height: 4px;
          background: #e98880;
        }
        .normalLineFlag {
          background: #fbeceb;
        }
      }
    }
    .contentBottom {
      .signName {
        font-size: 14px;
        color: #505050;
        text-align: center;
        line-height: 14px;
        margin-bottom: 10px;
        max-width: 180px;
      }
      .signNameNormal {
        color: #b4b4b4;
      }
      .signHandler {
        width: 180px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        background: #f5f5f5;
        font-size: 14px;
        display: flex;
        justify-content: space-around;
        // color: #e98880;
        color: #b4b4b4;
        margin: 0 auto;
        margin-bottom: 5px;
        .handler {
          color: #e98880;
        }
      }
      .bottomCustomer {
        background: #fbeceb;
        .blockLineDscp,
        .blockLineId {
          color: #ea8e87;
        }
        margin-bottom: 0;
      }
      .handlerTime {
        font-size: 12px;
        color: #ea8e87;
        text-align: center;
        line-height: 12px;
        margin-bottom: 10px;
      }
    }
  }
  .redLine {
    width: 30px;
    height: 300px;
    padding-top: 120px;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    .lineFlag {
      width: 30px;
      display: inline-block;
      height: 4px;
      background: #e98880;
    }
    .normalLineFlag {
      background: #fbeceb;
    }
  }
}
</style>
